import {Injectable} from "@angular/core";
import {environment} from "../../environments/environment";
import {catchError, map, Observable, throwError} from "rxjs";
import {HttpClient, HttpErrorResponse, HttpParams} from "@angular/common/http";
import {VehOnhold} from "../models/VehOnhold";

@Injectable({
  providedIn: 'root'
})
export class VehicleOnHoldService {
  private readonly vehicleOnHoldUrl = environment.vehicleOnHoldUrl;
  private readonly excelUrl = environment.excelUrl;
  vehOnholdParams: HttpParams;

  constructor(private readonly httpClient: HttpClient) { }

  getAllOnHoldRemitos(vehOnholdData: VehOnhold): Observable<VehOnhold[]> {
    this.getSearchParams(vehOnholdData);

    return this.httpClient.get<VehOnhold[]>(this.vehicleOnHoldUrl + '/on_hold_remitos', { params: this.vehOnholdParams }).pipe(map(
      allData => {
        return allData.map((allData) => {
          return VehOnhold.transformData(allData);
        })
      }),
      catchError(this.handleError));
  }

  getSearchParams(vehOnholdData: VehOnhold) {

    this.vehOnholdParams = new HttpParams();
    // @ts-ignore
    this.vehOnholdParams = this.vehOnholdParams.append('vinLetras', vehOnholdData.vinLetras);
    // @ts-ignore
    this.vehOnholdParams = this.vehOnholdParams.append('vinNumeros', vehOnholdData.vinNumeros);
    // @ts-ignore
    this.vehOnholdParams = this.vehOnholdParams.append('fecGen', vehOnholdData.fecGen);
    // @ts-ignore
    this.vehOnholdParams = this.vehOnholdParams.append('chargeToCode', vehOnholdData.chargeToCode);
    // @ts-ignore
    this.vehOnholdParams = this.vehOnholdParams.append('codDestino', vehOnholdData.codDestino);
  }

  releaseAutomaticOnholdVehRemitos(ptoEmision: string | null, nroRemito: number | null):  Observable<string> {
    return this.httpClient.put<string>(this.vehicleOnHoldUrl + '/release/' + ptoEmision + '/' + nroRemito, null);
  }

  downloadOnHoldExcel(vehOnholdData: VehOnhold): Observable<Blob> {
    this.getSearchParams(vehOnholdData);
    return this.httpClient.get(this.excelUrl + '/onHoldRemitos', {params: this.vehOnholdParams, responseType: 'blob'}).pipe(catchError(this.parseErrorBlob));
  }

  parseErrorBlob(err: HttpErrorResponse): Observable<any> {
    const reader: FileReader = new FileReader();
    let jsonError="";
    const obs = new Observable((observer: any) => {
      reader.onloadend = (e) => {
        console.log(JSON.parse((<any>e.target).result));
        observer.error(JSON.parse((<any>e.target).result));
        // alert("Error:\n" + (<any>e.target).result);
        observer.complete();
      }
    });
    reader.readAsText(err.error);
    return obs;
  }

  handleError(error: HttpErrorResponse) {
    return throwError(error);
  }
}
